import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Toaster } from 'react-hot-toast';

// Instrument SPA navigation to debug URL/port changes
(() => {
  try {
    const origPush = window.history.pushState;
    const origReplace = window.history.replaceState;
    window.history.pushState = function(...args) {
      const ret = origPush.apply(this, args);
      // Log after state change
      // eslint-disable-next-line no-console
      console.log('[SPA pushState]', { args, href: window.location.href });
      return ret;
    };
    window.history.replaceState = function(...args) {
      const ret = origReplace.apply(this, args);
      // eslint-disable-next-line no-console
      console.log('[SPA replaceState]', { args, href: window.location.href });
      return ret;
    };
    window.addEventListener('popstate', () => {
      // eslint-disable-next-line no-console
      console.log('[SPA popstate]', { href: window.location.href });
    });
  } catch {}
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <Toaster position="top-right" />
  </React.StrictMode>
);
